import React from 'react'
import Routes from 'router/routes'

const App = () => {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
